import {Injectable} from "@angular/core";
import {Observable} from "rxjs/Observable";
import {User} from "./user.model";
import {environment} from "../../../app/config/environment";
import {URLSearchParams} from "@angular/http";
import {MyHttp} from "../../../app/core/http";

@Injectable()
export class UserService {

  constructor(private http: MyHttp) {
  }

  getInterpreters(query){
    let params:URLSearchParams = new URLSearchParams();
    if(query){
      params.set('query', query);
    }

    return this.http.get(environment.API + '/users/interpreters', {search: params})
      .map(res => res.json());
  }

  getUsers(): Observable<User[]> {
    return this.http.get(environment.API + '/users')
      .map(res => res.json())
      .map(UserService.formatUsers);
  }

  getColleagues(query){
    let params:URLSearchParams = new URLSearchParams();
    if(query){
      params.set('query', query);
    }

    return this.http.get(environment.API + '/users/colleagues', {search: params})
      .map(res => res.json());
  }

  refer(email: string) {
    return this.http.post(`${environment.API}/users/refer/client`, JSON.stringify({
      email: email
    }))
      .map(res => res.json());
  }


  invite(email: string){
    return this.http.post(`${environment.API}/users/invite`, JSON.stringify({
      email: email
    }))
      .map(res => res.json());
  }


  private static formatUsers(users: User[]) {
    return users.map((user) => {
      user.text = `${user.first_name} ${user.last_name}`;
      return user;
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/shared/user/user.service.ts